// src/store/index.js - 更新版
import { createStore } from 'vuex'
import news from './modules/news'

export default createStore({
  state: {
    home: '',
    portfolios: []
  },
  getters: {
  },
  mutations: {
    setHome(state, home) {
      state.home = home
    },
    setPortfolios(state, portfolios) {
      state.portfolios = portfolios
    }
  },
  actions: {
  },
  modules: {
    news
  }
})